
export class GetOrderNumQuotaCodeListRequestModel {
  // 受注コード
  public orderCode: string = <string>'';

  // Ｐコード
  public pCode: string = <string>'';

  // 取得種類
  public getType: string = <string>'';

  // 媒体区分
  public mediumType: string = <string>'';
}
